// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jzliu-bi-engine-dws-preview[data-v-57ad89ad] {
  width: 100%;
  height: 100%;
}
[data-v-57ad89ad] .el-dialog__body {
  max-height: none;
}
[data-v-57ad89ad] .el-table__empty-block {
  min-height: 500px !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/base/preview/dwsPreview.vue","webpack://./dwsPreview.vue"],"names":[],"mappings":"AA+DA;EACE,WAAA;EACA,YAAA;AC9DF;ADiEA;EACE,gBAAA;AC/DF;ADiEA;EACE,4BAAA;AC/DF","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.jzliu-bi-engine-dws-preview {\n  width: 100%;\n  height: 100%;\n}\n\n/deep/ .el-dialog__body {\n  max-height: none;\n}\n/deep/ .el-table__empty-block{\n  min-height: 500px !important;\n}\n",".jzliu-bi-engine-dws-preview {\n  width: 100%;\n  height: 100%;\n}\n /deep/ .el-dialog__body {\n  max-height: none;\n}\n /deep/ .el-table__empty-block {\n  min-height: 500px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
